import { Globe } from "@/components/Svg";
import CMultiSelect from "@/components/main/form/CMultiSelect";
import Countries from "@/resources/countries.json";

const CountriesInput = ({ form, dictionary, placeholder, formValue }) => {
  return (
    <CMultiSelect
      searchable
      placeholder={placeholder ?? dictionary.countries}
      className="mt-3"
      icon={<Globe />}
      data={Countries}
      limit={5}
      hoverOnSearchChange={true}
      filter={(value, selected, item) => {
        return (
          item.value.toLowerCase().startsWith(value.toLowerCase()) && !selected
        );
      }}
      {...form.getInputProps(formValue ?? "countries")}
    />
  );
};

export default CountriesInput;
